import { Plan, SEGMENTOS_POS } from "@/api/products";
import useBreakpoint from "@/hooks/useBreakpoint";
import { useState } from "react";
import Accordion from "@/components/Accordion";
import AccordionItem from "@/components/Accordion/Item";
import ChevronDownIcon from "@/components/SVGs/ChevronDownIcon";
import MobileHeader from "@/components/MobileHeader";
import Header from "@/components/Header";
import CompositionPlan from "@/components/CompostionPlan";
import Button from "@/components/Button";
import BasePlan from "@/components/BasePlan";
import Benefits from "@/components/Benefits";

export interface ProductCardProps {
  product: Plan;
  to?: string;
  onSelect?(plan: Plan): void;
}

export default function ProductCard({
  product,
  onSelect,
  to,
}: ProductCardProps) {
  const { isOnBreakpoint: isTableOrLess } = useBreakpoint(1357);
  const [showAppBenefits, setShowAppBenefits] = useState(true);
  const isPos = SEGMENTOS_POS.includes(product.segmento);

  return (
    <article className="mb-4 flex flex-col rounded-2xl bg-white px-3 pt-3 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md lg:px-5 lg:pt-5">
      {isTableOrLess ? (
        <MobileHeader
          product={product}
          onSelect={onSelect}
          to={to}
          showAppBenefits={showAppBenefits}
        />
      ) : (
        <Header product={product} onSelect={onSelect} to={to} />
      )}

      <main>
        <Accordion className="pb-2">
          <AccordionItem
            name="social-items"
            labelPosition="center"
            showBottonCloseButton
            onToggle={() => setShowAppBenefits((old) => !old)}
            label={
              <div className="flex items-center justify-center pr-8 text-center text-gray-400">
                <ChevronDownIcon className="rotate-180 transform" />
                <span>ver menos</span>
              </div>
            }
            openLabel={
              <div className="flex items-center justify-center pr-8 text-center text-gray-400">
                <ChevronDownIcon />
                <span>ver mais vantagens</span>
              </div>
            }
            showToggleIcon={false}
            className="flex items-center justify-center"
          >
            <div className="flex flex-col items-start justify-start">
              <BasePlan gbPlan={product?.gbPadrao || 0} />
              <CompositionPlan
                gbPadrao={product?.gbPadrao}
                gbPromocional={product?.gbPromocional}
                gbBonusPortabilidade={product?.gbBonusPortabilidade}
                mostrarPortabilidade={product?.mostrarPortabilidade}
                gbBonusDedicado={product?.gbBonusDedicated}
                mostrarDedicado={product?.mostrarDedicado}
                isPos={isPos}
              />
              {product?.beneficios && (
                <Benefits benefits={product.beneficios} />
              )}
              <div className="w-2/3 self-center pb-2 pt-4">
                <Button large to={to} onClick={() => onSelect?.(product)}>
                  CONTRATAR AGORA
                </Button>
              </div>
            </div>
          </AccordionItem>
        </Accordion>
      </main>
    </article>
  );
}
